import { render, staticRenderFns } from "./SendingSchemes.vue?vue&type=template&id=54fd3812&scoped=true"
import script from "./SendingSchemes.vue?vue&type=script&lang=js"
export * from "./SendingSchemes.vue?vue&type=script&lang=js"
import style0 from "./SendingSchemes.vue?vue&type=style&index=0&id=54fd3812&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd3812",
  null
  
)

export default component.exports